import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritiesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priorities-delete',
	path: '/secure/admin/DeletePriority!default.jspa',
};
